/**
 * @generated SignedSource<<165d7305b697aeca2a04f514eaa7a90f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PollVoteType = "MULTIPLE" | "SINGLE" | "%future added value";
export type PollVoteVisibility = "ANONYMOUS" | "PUBLIC" | "%future added value";
export type pollQuery$variables = {
  id: string;
};
export type pollQuery$data = {
  readonly poll: {
    readonly dueDate: any | null | undefined;
    readonly id: string;
    readonly options: ReadonlyArray<{
      readonly id: string;
      readonly option: string;
      readonly votes: number;
    }>;
    readonly rawID: string;
    readonly title: string;
    readonly userPollVotes: ReadonlyArray<{
      readonly option: {
        readonly option: string;
      };
    }>;
    readonly voteType: PollVoteType;
    readonly voteVisibility: PollVoteVisibility;
  };
};
export type pollQuery = {
  response: pollQuery$data;
  variables: pollQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "option",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Poll",
    "kind": "LinkedField",
    "name": "poll",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dueDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "voteType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "voteVisibility",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollOption",
        "kind": "LinkedField",
        "name": "options",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "votes",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PollVote",
        "kind": "LinkedField",
        "name": "userPollVotes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PollOption",
            "kind": "LinkedField",
            "name": "option",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pollQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pollQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b7e66dd6775c8cd3a0d40bf1424ee1f9",
    "id": null,
    "metadata": {},
    "name": "pollQuery",
    "operationKind": "query",
    "text": "query pollQuery(\n  $id: ID!\n) {\n  poll(id: $id) {\n    id\n    rawID\n    dueDate\n    title\n    voteType\n    voteVisibility\n    options {\n      id\n      votes\n      option\n    }\n    userPollVotes {\n      option {\n        option\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "034e3b36169cb44055d13516e775b1d5";

export default node;
